import React from 'react';
import { FileText, Mic, Languages, Briefcase } from 'lucide-react';

const Services = ({ translations }) => {
  const services = [
    {
      icon: <FileText size={32} />,
      title: translations.services.translation.title,
      description: translations.services.translation.description
    },
    {
      icon: <Mic size={32} />,
      title: translations.services.interpretation.title,
      description: translations.services.interpretation.description
    },
    {
      icon: <Briefcase size={32} />,
      title: translations.services.interpreterB2B.title,
      description: translations.services.interpreterB2B.description
    },
    {
      icon: <Languages size={32} />,
      title: translations.services.languages.title,
      description: translations.services.languages.description
    }
  ];

  return (
    <section id="services" className="services-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{translations.services.title}</h2>
          <p className="section-subtitle">{translations.services.subtitle}</p>
        </div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                {service.icon}
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
